module.exports = __webpack_public_path__ + "img/spring_t2_washer.prt.df8b38e1.jpg";